export interface PaypalMessageClickedData {
  meta?: { offerType?: string };
}

export function isPaypalMessageLocale(locale: string): boolean {
  return locale.toLowerCase() === 'en-us';
}

export function calculatePaypalMessageVariant(data: PaypalMessageClickedData): string {
  const OfferTypeBelow30 = 'GPLNQ';
  const OfferTypeBetween30And200 = 'GPLQ';
  const OfferTypeAbove200 = 'LT_MQGZ';

  const amountBelowThirty = 'Amount below $30';
  const amountBetween30and200 = 'Amount between $30 and $200';
  const amountAbove200 = 'Amount more than $200';

  let detail: string = '';
  const offerType = data?.meta?.offerType;
  if (offerType) {
    if (offerType === OfferTypeBelow30) {
      detail = amountBelowThirty;
    } else if (offerType === OfferTypeBetween30And200) {
      detail = amountBetween30and200;
    } else if (offerType === OfferTypeAbove200) {
      detail = amountAbove200;
    }
  }

  return detail;
}
